import React, { CSSProperties, FC } from 'react'

interface Props {
  extraClasses?: string
  style?: CSSProperties
}

const CaretDown: FC<Props> = ({ extraClasses = '', style }) => (
  <span className={`Icon ${extraClasses}`} style={style}>
    <svg className="Icon-glyph" width="18" height="18" viewBox="-1 -2 8 8" xmlns="http://www.w3.org/2000/svg">
      <title>Caret down icon</title>
      <path d="M.707 0L0 .697 3.354 4 6.707.697 6 0 3.359 2.602z" fillRule="evenodd" />
    </svg>
  </span>
)

export default CaretDown
